var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-responsive',{staticClass:"base-divider mx-auto",class:_vm.classes,attrs:{"max-width":"40"}},[_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }